import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../../../auth/user.service';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';

@Component({
	selector: 'app-plink-tabs',
	templateUrl: './plink-tabs.component.html',
	styleUrls: ['./plink-tabs.component.css']
})
export class PlinkTabsComponent implements OnInit {

	@Input() device: any = {};
	@Input() plinkID: number = 0;
	@Input() customerID: number = 0;
	@Input() siteID: number = 0;
	@Input() activePage: string;
	@Input() analyticsTab: string;
	@Input() currentUser: any = {};

	@Output() onTabChanged = new EventEmitter<string[]>(true);

	constructor(
		public userService: UserService,
		private route: ActivatedRoute,
		private location: Location,
		private router: Router,
		private commonUtil: CommonUtil,
	) { }

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();
	}

	setTab(tabName, type, subTabName = "") {
		let url: any[] = [type];
		let queryParams = {};
		let updateSharedStudiesUrl = false;

		// Use plinkID directly instead of device.deviceid for more reliable navigation
		const deviceId = this.plinkID || (this.device && this.device.deviceid) || 0;

		switch(type) {
			case 'analytics':
			case 'notes':
			case 'settings':
			case 'quick-view':
			case 'plink-events':
			case 'rt-records':
				// Use consistent path parameter format for all tabs
				if(tabName)
					url.push(tabName);

				url.push(deviceId);

				if(subTabName) {
					url.push(subTabName);
				}
			break;
			case 'connectivity-track':
			case 'config-track':
			case 'debug-records':
				// These legacy pages still use query parameters
				if(deviceId) {
					queryParams['plinksIDs'] = deviceId;
				}
			break;
			case 'listing':
				// No additional params needed for listing
			break;
			default:
				url.push(deviceId);
			break;
		}

		if(updateSharedStudiesUrl)
			return this.router.navigate(url);

		if(type != 'analytics' || this.activePage != 'analytics')
			return this.router.navigate(url, {relativeTo: this.route.parent, 'queryParams': queryParams});

		this.location.go(
			this.router.createUrlTree(
				url,
				{relativeTo: this.route.parent, 'queryParams': queryParams}
			).toString()
		);
		this.onTabChanged.emit([type, tabName, subTabName]);
	}

	isAnalyticsSet(tab) {
		if(this.activePage == 'analytics' && tab == this.analyticsTab)
			return true;
		return false;
	}
}
